module.exports = __webpack_public_path__ + "media/images/beta-2-957dd95fe98f63fbedd49f71035e79be.png";